import React from 'react';
import { CTAButton } from './CTAButton';
import { PRICE } from './salesData';
import { PHOTOS } from '../data/photos';
export function FinalCta() {
  return <section className="bg-white pb-10 pt-11 sm:pb-14 sm:pt-16" data-id="element-65" data-mp="vhajid21if0t">
      <div className="mx-auto max-w-md px-5 text-center sm:max-w-2xl" data-id="element-66" data-mp="19fqkroh4vdbk">
        <img src={PHOTOS.finale} alt="Colección de jabones artesanales de glicerina en distintos estilos, colores y formas" loading="lazy" decoding="async" className="mb-6 h-28 w-full rounded-2xl object-cover sm:h-36" data-id="element-67" data-mp="15cuacl1qynip" />

        <h2 className="mx-auto max-w-[24ch] font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-[2rem]" data-id="element-68" data-mp="1t2yb8knjw960">
          No se trata de leer 200 fórmulas.
          <span className="mt-1.5 block font-accent text-[1.1rem] font-medium tracking-normal text-gold-deep sm:text-[1.45rem]" data-id="element-69" data-mp="223mgapuyuz6r">
            Se trata de encontrar el primer jabón que quieras fabricar.
          </span>
        </h2>

        <p className="mt-5 font-sans text-[0.95rem] font-semibold text-charcoal" data-id="element-70" data-mp="n6e3fhgh49u9">
          <span className="mr-2 font-medium text-taupe" data-id="element-71" data-mp="s4filras3p0g">
            Antes <span style={{
            textDecoration: 'line-through'
          }} data-id="element-72" data-mp="s6rzs28ppvcg">{PRICE.previous}</span>
          </span>
          {PRICE.current}
        </p>

        <div className="mt-4 flex justify-center" data-id="element-73" data-mp="123ejuot7sidf">
          <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-74" data-mp="1246g81umyk4r" />
        </div>

        <p className="mx-auto mt-2.5 max-w-[34ch] font-sans text-[0.74rem] font-semibold leading-snug text-gold-deep" data-id="element-75" data-mp="163f6uxudq1w3">
          {PRICE.note}
        </p>
      </div>
    </section>;
}